import * as React from 'react'

import { loadEnvironment } from 'Common/environment'

export const baseLoader = (
    Component: React.ComponentType<any>,
    handleError: (error: unknown) => void,
) => {
    return class BaseLoader extends React.Component {
        state = {
            envLoaded: false,
        }

        componentDidMount() {
            loadEnvironment()
                .then(() => this.setState({ envLoaded: true }))
                .catch(handleError)
        }

        render() {
            if (!this.state.envLoaded) return null
            return <Component {...this.props} />
        }
    }
}
